var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cookies'),_c('main-header'),_c('main',[_c('h1',{staticClass:"visually-hidden",attrs:{"id":"main-container"}},[_vm._v("Comune di Perugia")]),_c('router-view',{key:_vm.key})],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }